module.exports = __webpack_public_path__ + "static/kenku-artificer-6daadb8178cec58bdbec4bf6cd636a5e.jpg";